
import api from '~/services/api';
import PropTypes from 'prop-types';
import errorHandler from '~/Utils/errorHandler';
import { message } from 'antd';
import i18next from 'i18next';

const endPoint = 'invoices';

// PAGINATION
export const paginationInvoices = async params => {
  try {
    const { data } = await api.post(`/${endPoint}/pagination`, params);
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// FIND ALL
export const findAllInvoices = async (filters) => {
  try {
    const { data } = await api.post(`/${endPoint}/findAll`, filters);
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// CREATE
export const createInvoice = async values => {
  try {
    const { data } = await api.post(`/${endPoint}/create`, values);
    message.success(i18next.t(`messages:${endPoint}.success`));
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// UPDATE
export const updateInvoice = async values => {
  try {
    const { data } = await api.put(`/${endPoint}/update`, values);
    message.success(i18next.t(`messages:${endPoint}.successEdit`));
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// UPDATE ALL
export const updateAllInvoice = async values => {
  try {
    const { data } = await api.put(`/${endPoint}/updateAll`, values);
    message.success(i18next.t(`messages:${endPoint}.successEdit`));
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// DELETE
export const deleteInvoice = async id => {
  try {
    const { data } = await api.delete(`/${endPoint}/delete/${id}`);
    message.success(i18next.t(`messages:${endPoint}.successDelete`));
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// SEND INVOICE TO CLIENT
export const sendInvoice = async id => {
  try {
    const { data } = await api.post(`/mail/sendInvoice/${id}`);
    message.success(i18next.t(`messages:${endPoint}.successSendInvoice`));
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

paginationInvoices.propTypes = {
  params: PropTypes.object.isRequired,
};

findAllInvoices.propTypes = {
  filters: PropTypes.object.isRequired,
};

createInvoice.propTypes = {
  values: PropTypes.object.isRequired,
};

updateInvoice.propTypes = {
  values: PropTypes.object.isRequired,
};

updateAllInvoice.propTypes = {
  values: PropTypes.object.isRequired,
};

deleteInvoice.propTypes = {
  id: PropTypes.string.isRequired,
};

sendInvoice.propTypes = {
  id: PropTypes.string.isRequired,
};
